/*eslint-disable*/
export default popUp => {
  let $popUp = $(popUp)
  $popUp.find('.snowe-button-global').click(() => {
    $popUp.addClass('transparent')
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/registry-popup.js